import get from 'lodash/get';
import remove from 'lodash/remove';
export function sortItems(items, orderDefinition) {
  function sort(orderedItems, orderDef) {
    orderDef.forEach(def => {
      const subSet = remove(orderedItems, def.filter);
      if (!def.values.length) {
        const values = subSet.map(t => get(t, def.key));
        values.sort();
        def.values = [...new Set(values)];
      }
      subSet.sort((a, b) => def.values.indexOf(get(a, def.key)) - def.values.indexOf(get(b, def.key)));
      if (Array.isArray(def.subDef) && def.subDef.length) {
        def.values.forEach(value => {
          const subSetDef = def.subDef.map(def_ => ({
            ...def_,
            filter: t => def.filter(t) && get(t, def.key) === value && def_.filter(t)
          }));
          sort(subSet, subSetDef);
        });
      }
      orderedItems.push(...subSet);
    });
  }
  const orderedItems = items.slice(0);
  sort(orderedItems, orderDefinition);
  return orderedItems;
}
export const productsOrderDef = [{
  filter: () => true,
  key: 'productType',
  values: ['domain', 'mailboxv2', 'certificate', 'paas', 'iaas'],
  subDef: [{
    filter: () => true,
    key: 'process',
    values: ['create', 'renew', 'restore', 'transfer'],
    subDef: []
  }, {
    filter: p => p.productType === 'mailboxv2',
    key: 'payload.fqdn',
    values: [],
    subDef: [{
      filter: () => true,
      key: 'payload.mailbox_type',
      values: ['standard', 'premium'],
      subDef: []
    }]
  }]
}];
export const productOptionsOrderDef = [{
  filter: o => o.productType === 'mailboxv2',
  key: 'mailboxType',
  values: ['standard', 'premium'],
  subDef: []
}];